<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('closeModal')">
                <div class="row">
                    <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
                    <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
                        <div class="modal-container" @click.stop>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-8">
                                        <h2
                                            class="title"
                                            style="margin-bottom: 20px"
                                        >
                                            Register New User
                                        </h2>
                                    </div>
                                    <div class="offset-3 col-1">
                                        <button
                                            type="button"
                                            class="close"
                                            @click="$emit('closeModal')"
                                            style="
                                                font-size: 20px;
                                                color: #db5757;
                                                opacity: 1;
                                            "
                                        >
                                            <i class="fa fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                                <template v-if="!uploadExcel">
                                    <div class="row row-space">
                                        <div
                                            class="col-xs-12 col-lg-6 first-field"
                                        >
                                            <div class="input-group">
                                                <label class="label"
                                                    >Full Name </label
                                                >
                                                <input
                                                    class="input--style-4"
                                                    type="text"
                                                    name="name"
                                                    v-model="form.name"
                                                    placeholder="Input Nama Lengkap"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            class="col-xs-12 col-lg-6 second-field"
                                        >
                                            <div class="input-group">
                                                <label class="label"
                                                    >Username </label
                                                >
                                                <input
                                                    class="input--style-4"
                                                    type="text"
                                                    name="username"
                                                    v-model="form.username"
                                                    placeholder="Input Username"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row row-space">
                                        <div
                                            class="col-xs-12 col-sm-6 col-md-6 col-lg-6 first-field"
                                        >
                                            <div class="input-group">
                                                <label class="label"
                                                    >Password </label
                                                >
                                                <input
                                                    class="input--style-4"
                                                    type="password"
                                                    name="password"
                                                    v-model="form.password"
                                                    placeholder="Input Password"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            class="col-xs-12 col-sm-6 col-md-6 col-lg-6 second-field"
                                        >
                                            <div class="input-group">
                                                <label class="label"
                                                    >Re-type Password </label
                                                >
                                                <input
                                                    class="input--style-4"
                                                    type="password"
                                                    name="retype_password"
                                                    v-model="retype_password"
                                                    placeholder="Input Password Kembali"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row row-space">
                                        <div
                                            class="col-xs-12 col-sm-6 col-md-6 col-lg-6 first-field"
                                        >
                                            <div class="input-group">
                                                <label class="label"
                                                    >User Type </label
                                                >
                                                <MultiSelect
                                                    v-model="form.type"
                                                    :options="[
                                                        'USER_DEALER',
                                                        'SUPER_ADMIN',
                                                        'USER_MAIN_DEALER'
                                                    ]"
                                                    :allow-empty="false"
                                                    placeholder="Choose Type"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                        <div
                                            class="col-xs-12 col-sm-6 col-md-6 col-lg-6 second-field"
                                        >
                                            <div class="input-group">
                                                <label class="label"
                                                    >Status </label
                                                >
                                                <MultiSelect
                                                    v-model="form.status"
                                                    :options="[0, 1]"
                                                    :custom-label="
                                                        (opt) =>
                                                            opt
                                                                ? 'Active'
                                                                : 'Inactive'
                                                    "
                                                    :allow-empty="false"
                                                    placeholder="Choose Status"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row row-space">
                                        <div
                                            class="col-xs-12 col-lg-6 first-field"
                                        >
                                            <div class="input-group">
                                                <label class="label"
                                                    >NPK</label
                                                >
                                                <input
                                                    class="input--style-4"
                                                    type="text"
                                                    name="name"
                                                    v-model="form.npk"
                                                    placeholder="Input NPK User"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            class="col-xs-12 col-lg-6 second-field"
                                            v-if="form.type != 'SUPER_ADMIN'"
                                        >
                                            <div class="input-group">
                                                <label class="label"
                                                    >{{
                                                        form.type ==
                                                        'USER_MAIN_DEALER'
                                                            ? 'Region'
                                                            : 'Permission'
                                                    }}</label
                                                >
                                                <MultiSelect
                                                    v-if="
                                                        form.type !=
                                                        'USER_MAIN_DEALER'
                                                    "
                                                    v-model="form.permission"
                                                    :options="
                                                        options.dealer.map(
                                                            (x) => x.loc_code
                                                        )
                                                    "
                                                    :custom-label="
                                                        (opt) =>
                                                            options.dealer.find(
                                                                (x) =>
                                                                    x.loc_code ==
                                                                    opt
                                                            ).showName
                                                    "
                                                    :allow-empty="false"
                                                    :multiple="false"
                                                    placeholder="Choose Permission ( Isi 2 Karakter Untuk Cari )"
                                                    :internal-search="false"
                                                    @search-change="
                                                        searchDealer
                                                    "
                                                ></MultiSelect>

                                                <MultiSelect
                                                    v-else
                                                    v-model="form.permission"
                                                    :options="
                                                        options.region.map(
                                                            (x) => x.region_code
                                                        )
                                                    "
                                                    :custom-label="
                                                        (opt) =>
                                                            options.region.find(
                                                                (x) =>
                                                                    x.region_code ==
                                                                    opt
                                                            ).fullname
                                                    "
                                                    :allow-empty="false"
                                                    :multiple="false"
                                                    placeholder="Choose Region"
                                                ></MultiSelect>
                                            </div>
                                        </div>
                                    </div>
									<div class="row">
										<div class="col-lg-2 col-6 mt-3">
											<button
												type="button"
												class="btn btn-dark-blue w-100"
												@click="uploadExcel = true"
											>
												Upload Excel
											</button>
										</div>
										<div class="col-lg-3 col-6 mt-3">
											<a
												class="btn w-100"
												download
												href="/template-upload-user.xlsx"
											>
												<i class="fa fa-download"></i>
												Download Template
											</a>
										</div>
										<div
											class="offset-lg-3 col-lg-2 col-6 mt-3"
										>
											<button
												type="button"
												class="btn btn-dark-blue-outline w-100"
												@click="$emit('closeModal')"
											>
												Batal
											</button>
										</div>
										<div class="col-lg-2 col-6 mt-3 w-100">
											<button
												type="button"
												class="btn btn-green w-100"
												@click="submitForm()"
											>
												Add New User
											</button>
										</div>
									</div>
                                </template>
								<template v-else>
									<div style="border: 2px dotted #707070" class="p-10">
										<div class="bg-white h-100 rounded  mt-5" @drop.prevent="validateSize" @dragover.prevent style="min-height:200px;">
											<div style="color:#ccc" class="text-center">
												<img src="@/assets/img/UploadLogo.png" />
												<br>
												<span>Drop Files Here</span>
												<br>
												<span>Or</span>
												<br>
												<br>
												<input type="file" class="btn btn-dark-blue w-50" @change="validateSize" placeholder="Select Files">
											</div>
											
										</div>
									</div>
									<div class="row">
										<div class="col-lg-2 col-6 mt-3">
											<button
												type="button"
												class="btn btn-dark-blue-outline w-100"
												@click="uploadExcel = false"
											>
												Input User Manual
											</button>
										</div>
										<div
											class="offset-lg-6 col-lg-2 col-6 mt-3"
										>
											<button
												type="button"
												class="btn btn-dark-blue-outline w-100"
												@click="$emit('closeModal')"
											>
												Batal
											</button>
										</div>
										<div class="col-lg-2 col-6 mt-3 w-100">
											<button
												type="button"
												class="btn btn-green w-100"
												@click="uploadFile"
											>
												Upload Excel
											</button>
										</div>
									</div>
								</template>
                                <!-- Button Starts -->
                                
                                <!-- Button Ends -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
            </div>
        </div>
    </transition>
</template>

<script>
import MultiSelect from 'vue-multiselect';
import modulesList from './modulesList.json';

export default {
    data() {
        return {
            mobile: this.isMobile(),
            options: {
                status: this.$store.getters.getFilterOptions.status,
                dealer: []
            },
            form: {
                name: '',
                username: '',
                password: '',
                type: 'USER_DEALER',
                status: 1,
                permission: '',
                npk: ''
            },
            retype_password: '',
            moduleConfig: null,
            selectModule: [],
            structure: [],
            selected: [],
            uploadExcel: false,
			file : null
        };
    },
    directives: {
        indeterminate: function (el, binding) {
            el.indeterminate = Boolean(binding.value);
        }
    },
    components: {
        MultiSelect
    },
    mounted() {
        // this.generateStructure();
        this.loadRegion();
    },
    watch: {
        'form.type' : function () {
            this.form.permission = ''
        }
    },
    methods: {
		validateSize : function(data){
            var file = data.dataTransfer ? data.dataTransfer.files[0] : data.target.files[0];
			// console.log(file)

            if(file.type != "text/csv" && file.type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' && file.type != 'application/vnd.ms-excel')
            {
                this.fileError = "Unsupported File Type! Only accepts CSV or XLSX Files";
                return false;
            }

            var size  = file.size / 1024 / 1024;

            if(size > 2)
            {
                this.fileError = "File size is too big";
                return false;
            }

            this.fileError = "";
            this.file = file;
            return true;
        },
		uploadFile () {
			console.log('Uploading....')
			let vm = this;
            let url = "/api/upload-user"

			if(!this.file) {
				vm.$emit(
					'triggerAlert',
					true,
					'Please Upload Document First Before Submitting Document.'
				);
				return;
			}

            let formData = new FormData()

            formData.append('file' , this.file)
            this.$http.post(url , formData , {headers : {"Content-Type":'multipart/form-data'}})
            .then((resp) => {
				vm.$emit('triggerAlert', false, [
					`Upload File Berhasil`
				]);
			})
			.catch((err) => {
				console.log(err.response.data);
				vm.$emit(
					'triggerAlert',
					true,
					err.response.data.message
				);
			});
		},
        async searchDealer(query) {
            let dealerList = await this.$store.getters.getDealer();
            dealerList = dealerList.filter(
                (x) =>
                    x.showName.toLowerCase().includes(query.toLowerCase()) &&
                    query.length > 1
            );
            this.options.dealer = dealerList;
        },
        async loadRegion() {
            try {
                let response = await this.$http.get('/api/master/region');

                let data = response.data.data.map((x) => {
                    return {
                        ...x,
                        fullname: x.region_code + ' - ' + x.name
                    };
                });

                this.$set(this.options, 'region', data);
            } catch (err) {
                console.log(err);
            }
        },
        openBox(index) {
            if (this.structure[index].children == null) return;
            for (var i in this.moduleConfig) {
                if (i == index)
                    this.moduleConfig[index].boxOpen =
                        !this.moduleConfig[index].boxOpen;
                else this.moduleConfig[i].boxOpen = false;
            }
        },

        validateForm() {
            var valid = true;
            var error = [];

            if (this.form.name == '' || this.form.name == null) {
                //Full Name [Required]
                valid = false;
                error.push('Full Name is a required Field!');
            }

            if (this.form.username == '' || this.form.username == null) {
                //Username [Required]
                valid = false;
                error.push('Username is a required Field!');
            }

            if (this.form.password == '' || this.form.password == null) {
                //Password [Required]
                valid = false;
                error.push('Password is a required Field!');
            }

            if (this.retype_password == '' || this.retype_password == null) {
                //Retype Password [Required]
                valid = false;
                error.push('Retype Password is a required Field!');
            } else {
                if (this.form.password !== this.retype_password) {
                    //Password and Retype Password Not The Same
                    valid = false;
                    error.push('Password and Re-Type Password does not match!');
                }
            }

            // if(this.form.permission.length == 0){//Region View Access [Required]
            //   valid = false;
            //   error.push('Region View Access has to have at least one region');
            // }

            // if(this.form.modules.length == 0){//Modules [Required]
            //   valid = false;
            //   error.push('Modules has to have at least one module selected');
            // }

            if (!valid) this.$emit('triggerAlert', !valid, error);
            else return valid;
        },
        async submitForm() {
            let vm = this;
            if (await vm.validateForm()) {
                if(this.form.type == 'SUPER_ADMIN') delete this.form.permission
                this.$http
                    .post('/api/save-user', this.form)
                    .then((resp) => {
                        // alert(`Partshop ${vm.form.name} has been created`);
                        vm.$emit('triggerAlert', false, [
                            `User Region ${vm.form.username} has been created`
                        ]);
                    })
                    .catch((err) => {
                        console.log(err);
                        vm.$emit(
                            'triggerAlert',
                            true,
                            err.data.message.split(',')
                        );
                    });
            }
        }
    }
};
</script>

<style scoped>
/* ==========================================================================
	#FORM made by Colorlib (https://colorlib.com)
	========================================================================== */
input {
    outline: none;
    margin: 0;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
    width: 100%;
    font-size: 14px;
    font-family: inherit;
}

.input--style-4 {
    line-height: 40px;
    background: #fff;
    /* -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08); */
    border : 1px solid #CECECE;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    border-radius: 5px;
    padding: 0 20px;
    font-size: 16px;
    /* color: #666; */
    -webkit-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
    /* WebKit, Blink, Edge */
    color: #CECECE;
}

.input--style-4:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #CECECE;
    opacity: 1;
}

.input--style-4::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #CECECE;
    opacity: 1;
}

.input--style-4:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #CECECE;
}

.input--style-4:-ms-input-placeholder {
    /* Microsoft Edge */
    color: #CECECE;
}

.label {
    font-size: 12px;
    color: #5D5D5D;
    text-transform: capitalize;
    display: block;
    margin-bottom: 5px;
}

.radio-container {
    display: inline-block;
    position: relative;
    padding-left: 30px;
    cursor: pointer;
    font-size: 16px;
    color: #666;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

.radio-container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
    background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
    display: block;
}

.radio-container .checkmark:after {
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    -o-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 12px;
    height: 12px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    background: #57b846;
}

.checkmark {
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #e5e5e5;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
    box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
    content: '';
    position: absolute;
    display: none;
}

.input-group {
    position: relative;
    /* margin-bottom: 22px; */
    padding: 20px;
}

.input-group-icon {
    position: relative;
}

.input-icon {
    position: absolute;
    font-size: 18px;
    color: #999;
    right: 18px;
    top: 50%;
    -webkit-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -o-transform: translateY(-50%);
    transform: translateY(-50%);
    cursor: pointer;
}

/* ==========================================================================
	#TITLE made by Colorlib (https://colorlib.com)
	========================================================================== */
.title {
    font-size: 16px;
    color: #525252;
    margin-bottom: 40px;
    text-align: center;
}

.modal-body {
    max-height: 80vh;
    overflow-y: auto;
    overflow-x: auto;
}
.innerBox {
    padding: 1.5rem 1.5rem 1.5rem 2.25rem;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    background-color: white;
    box-shadow: 2px 2px 5px #e0e0e0;
}
.custom-control {
    margin-bottom: 0;
}

.hoverable:hover {
    cursor: pointer;
}
.input-group {
    padding-left: 0;
    padding-right: 0;
}

.first-field {
    padding-right: 3.5%;
}

.second-field {
    padding-left: 3.5%;
}
.flex-middle {
	text-align: center;
}
</style>
